import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_editAddress = _resolveComponent("editAddress")!
  const _component_FormDialog = _resolveComponent("FormDialog")!

  return (_openBlock(), _createBlock(_component_FormDialog, {
    ref: "formDialogRefs",
    title: _ctx.formType=='edit' ? '编辑地址': '新增地址',
    width: "800px",
    labelWidth: "100px",
    formData: _ctx.editFormData,
    rules: _ctx.rules,
    showErrorToast: false,
    validateOnRuleChange: false,
    visible: _ctx.visibleRef,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visibleRef) = $event)),
    saveForm: _ctx.saveFormHandle
  }, {
    default: _withCtx(() => [
      _createVNode(_component_editAddress, {
        formData: _ctx.editFormData,
        "onUpdate:formData": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editFormData) = $event)),
        visible: _ctx.visibleRef,
        formType: _ctx.visibleRef
      }, null, 8, ["formData", "visible", "formType"])
    ]),
    _: 1
  }, 8, ["title", "formData", "rules", "visible", "saveForm"]))
}